import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useRouter } from "next/navigation";
import { flushCart } from "@/store/cart/cartSlice";
import { createOrderApi, flushCartApi } from "@/clientSideApi/cart";
import { setExpertInfo } from "@/store/general/generalSlice";
import { toast } from "react-toastify";
import useCashfree from "@/components/CustomUI/hooks/useCashfree";


const usePayment = () => {
    const router = useRouter();
    const isLoggedIn = useSelector((state) => state.general.user && state.general.user.token);
    const total_price = useSelector((state) => state.cart.data.cart.total_price);
    const shipping_address = useSelector((state) => state.cart.data?.shipping_address);
    const { content, notify, addressIsValid, emailIsValid } = useSelector((state) => state.cart);
    const addressValidated = shipping_address && addressIsValid;

    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);
    const [orders, setOrders] = useState(null);
    const [paymentModal, setPaymentModal] = useState(false);

    const onPaymentSuccess = async ({ order_token, prepayment_percentage }) => {
        await flushCartApi()
        if (order_token && prepayment_percentage !== 0) {
            router.replace(`/orders/${order_token}/payment/`);
        } else if (order_token && prepayment_percentage == 0) {
            router.replace(`/orders/${order_token}/`);
        } else {
            router.replace(`/orders/`);
        }
        dispatch(flushCart());
    };

    const { handleCashFreeModal } = useCashfree({ 
        token: null,
        onPaymentSuccess, 
        setPaymentModal 
    });

    const onOpenChange = (val) => {
        setPaymentModal(val);
    }

    const handlePaymentClick = async (orders_data, prepayment_percentage = 100) => {
        if (prepayment_percentage == 0 || !orders_data.payment_context) {
            toast.success("Order Placed Successfully.", {
                position: "top-right",
                autoClose: 2500,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
            return onPaymentSuccess({
                order_token: orders_data.order_token,
                prepayment_percentage,
            });
        }
        handleCashFreeModal(prepayment_percentage, orders_data);
    };

    const handlePress = async ({ prepayment_percentage }) => {
        if(!isLoggedIn && !emailIsValid){
            const anonEmail = document.getElementById('anonEmail');
            const anonEmailLabel = document.getElementById("anonEmailLabel");
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
            });
            anonEmail.classList.remove('border-slate-300');
            anonEmail.classList.add('border-[red]');
            anonEmailLabel.style.visibility = "visible";
            return
        }
        if (loading) return;
        if (!orders) {
            setLoading(prepayment_percentage === 100 ? 'pay' : "delivery");
            const apiResponse = await createOrderApi({
                content,
                notify_customer: notify,
                prepayment_percentage,
            });
            setLoading(false);
            if (!apiResponse || !apiResponse.order_token) return;
            setOrders(apiResponse);
            handlePaymentClick(apiResponse, prepayment_percentage);
            if (apiResponse.lead) {
                const data = JSON.stringify(apiResponse.lead);
                localStorage.setItem("expert_info", data);
                dispatch(setExpertInfo(apiResponse.lead));
            }
        } else {
            handlePaymentClick(orders, prepayment_percentage);
        }
    };

    return {
        loading,
        total_price,
        paymentModal,
        addressValidated,
        onOpenChange,
        handlePress,
    }
}

export default usePayment